import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/693bcda5e534c90014a57c10/gencarbon_esg/src/app/golf-course-hub/page.tsx");
